<amp-key-metrics-status-card
  [config]="config"
  [monitoringDataDataState]="monitoringDataDataState"
  [cardConfig]="cardConfig"
  [monitoringData]="monitoringData"
  [monitoringDate]="monitoringDate"
  [showCompactView]="showCompactView">
</amp-key-metrics-status-card>
